import './sidebar.scss';

import React, { FunctionComponent } from 'react';

import { useCharityData } from '../../context/charityContext';
import { useSideBarConfig } from './sideBarConfig';
import { useTranslation } from 'react-i18next';

export const SideBar: FunctionComponent = () => {
  const charityData = useCharityData();
  const { t } = useTranslation();

  const { heading, links } = useSideBarConfig(
    charityData?.charity?.operatingCompanyCode,
  );

  if (!charityData?.charity?.operatingCompanyCode) {
    return null;
  }

  return (
    <>
      <nav
        className="sidebar-wrapper jg-space-mbmd"
        aria-labelledby="sidebar-heading-gclinks"
      >
        <h2 className="jg-h3" id="sidebar-heading-gclinks">
          {t('home.discover.heading')}
        </h2>
        <ul className="sidebar-link-wrapper">
          <li>
            <a
              href="https://www.justgiving.com/for-charities/products/online-giving-checkout"
              className="sidebar-link"
              target="_blank"
              rel="noreferrer"
            >
              {t('home.discover.introductionLink')}
            </a>
          </li>
          <li>
            <a
              href="https://justgiving-charity-support.zendesk.com/hc/en-us/sections/360005258518-Giving-Checkout"
              className="sidebar-link"
              target="_blank"
              rel="noreferrer"
            >
              {t('home.discover.faqLink')}
            </a>
          </li>
          <li>
            <a
              href="https://blog.justgiving.com/get-the-most-out-of-giving-checkout-7-inspiring-charity-examples/"
              className="sidebar-link"
              target="_blank"
              rel="noreferrer"
            >
              {t('home.discover.testimonials')}
            </a>
          </li>
        </ul>
      </nav>
      <nav
        className="sidebar-wrapper"
        aria-labelledby="sidebar-heading"
        data-qa="sidebar"
      >
        <h2 className="jg-h3" id="sidebar-heading">
          {heading}
        </h2>
        <ul className="sidebar-link-wrapper">
          {links.map((link) => {
            return (
              <li key={`sidebar-link-${link.text}`}>
                <a
                  href={link.url}
                  className="sidebar-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.text}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
};
